import { useForm } from '../../../../libs/hooksLib';
import {
    useGetTypesForDropdownQuery,
    useListAssetEntriesQuery,
} from '../../../../services/fixedAssets/fixedAssets.service';
import { AssetEntryListParams } from '../../../../types/FixedAsset.types';
import { isNil, isNilOrEmpty } from '../../../../utils/objectUtils';
import { SelectionOption } from '../../../../types/Shared.types';
import { skipToken } from '@reduxjs/toolkit/query';
import { useContext, useEffect, useState } from 'react';
import { AssetEntryOptionsProps } from '../AssetEntryOptionsModal';
import SettingsContext from '../../../../contexts/settings.context';
import { useGetTermSetQuery } from '../../../../services/i18n/i18n.service';
import { ACCOUNTING_DEFS } from '../../../../constants/i18n/translations/termSetDefinitions/accounting';

const useAssetEntryOptionsModal = (props: AssetEntryOptionsProps) => {
    const initialFields: any = {
        assetTypes: [],
        startDate: null,
        endDate: null,
    };
    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: ACCOUNTING_DEFS.ASSET_ENTRIES_GRID,
              }
            : skipToken
    );
    const { fields, handleFieldChange } = useForm(initialFields);
    const [queryParams, setQueryParams] = useState<AssetEntryListParams>(null);

    const { data: assetTypeOptions, isLoading: loadingAssetTypes } =
        useGetTypesForDropdownQuery();

    const { data: assetEntryList, isFetching: isLoadingEntries } =
        useListAssetEntriesQuery(queryParams ? queryParams : skipToken);

    const handleGetAssetEntries = (event: any) => {
        event.preventDefault();
        const listParams: AssetEntryListParams = {};

        if (!isNilOrEmpty(fields.assetTypes)) {
            listParams['assetTypeIds'] = fields.assetTypes.map(
                (option: SelectionOption) => option.value
            );
        }
        if (!isNil(fields.startDate)) {
            listParams['startDate'] = fields.startDate;
        }
        if (!isNil(fields.endDate)) {
            listParams['endDate'] = fields.endDate;
        }

        setQueryParams(listParams);
    };

    useEffect(() => {
        if (assetEntryList) {
            props.onAssetEntriesLoaded(assetEntryList);
            props.onClose();
        }
    }, [assetEntryList]);

    return {
        queryParams,
        fields,
        handleFieldChange,
        assetTypeOptions,
        loadingAssetTypes,
        handleGetAssetEntries,
        isLoadingEntries,
        termSet,
    };
};

export default useAssetEntryOptionsModal;
